export function init() {
    const configurator_body = document.getElementById('js-init-config-block');
    
    if (configurator_body) {
        if (configurator_body.dataset.version === "v1") {
            import(/* webpackPrefetch: true */'./ProductPageLoader').then(
                module => new module.ProductPageLoader()
            );
        }
    }
}